import { post, handleErrors, get, patch, put } from "./requests";
import { URL_BASE } from "./constants";
import { Store } from "../redux/store";
import { showWarning, showSuccess } from "../redux/actions/snackbarActions";
import { decodeTokenJsonUser } from "../shared/helpers/jwtDecoder";
import { loadDemands } from "../redux/actions/demandActions";

async function getAllGoldenDemands() {
    const token = Store.getState().authState.loggedUser;
    const idCompany = decodeTokenJsonUser(token).company_identifier;
    const url = `${URL_BASE}/demands/company/${idCompany}`;
    const payload = await get(url, null, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }, (error) => {
        const { status, data } = error;
        handleErrors(status, data);
    });

    Store.dispatch(loadDemands(payload.data));
    return payload.data;
}

async function getAllDemands() {
    const url = `${URL_BASE}/demands/backoffice`;
    const demands = await get(url);
    Store.dispatch(loadDemands(demands.data));
    return demands.data;
}

async function createDemandAndAccount(fullName, 
    emailAddress, 
    phoneNumber, 
    category, 
    subcategory, 
    description,
    isFullTime, 
    requirements, 
    zipCode,
    city,
    stateCode,
    price) {
    const demandAccount = {
        fullName,
        emailAddress,
        phoneNumber,
        category,
        subcategory,
        description,
        isFullTime,
        requirements,
        zipCode,
        city,
        stateCode,
        price
    }

    await post(`${URL_BASE}/demands/web-third-party`, demandAccount, {
        headers: {
            'Authorization': `Bearer ${Store.getState().authState.loggedUser}`
        }
    },
        (error) => {
            const { status, data } = error;
            handleErrors(status, data);
        });

        await getAllDemands();

        Store.dispatch(showSuccess("Successfully added demand!"));
}

async function changeStatus(id, isActive) {
    const token = Store.getState().authState.loggedUser;
    const url = `${URL_BASE}/demands/${id}/status?isActive=${isActive}`;
    const response = await patch(url, null, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }, (error) => {
        const { status, data } = error;
        handleErrors(status, data);
    });
    if (!response.success) {
        throw Error(response.data);
    }
}

async function deleteDemand(id) {
    const token = Store.getState().authState.loggedUser;

    const url = `${URL_BASE}/demands/${id}/status?isActive=false&isBackoffice=true`;
    const response = await put(url, null,  {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }, (error) => {
        const { status, data } = error;
        handleErrors(status, data);
    });
    if (!response.success) {
        throw Error(response.data);
    }

    await getAllDemands();

    Store.dispatch(showSuccess("Successfully deleted demand!"));
}

async function finishDemand(id) {
    const token = Store.getState().authState.loggedUser;

    const url = `${URL_BASE}/demands/${id}/finish?isBackoffice=true`;
    const response = await put(url, null,  {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }, (error) => {
        const { status, data } = error;
        handleErrors(status, data);
    });
    if (!response.success) {
        throw Error(response.data);
    }

    await getAllDemands();

    Store.dispatch(showSuccess("Demand successfully completed!"));
}

async function createGoldenDemand(idCompany, category, subcategory, city, stateCode, description, price, isFullTime, requirements,
    zipCode, customerContact, customerName, isExclusive) {
    const goldenDemand = {
        idCompany,
        category,
        subcategory,
        city,
        stateCode,
        description,
        requirements,
        zipCode,
        customerContact,
        customerName,
        isFullTime: Boolean(isFullTime),
        price: price ? parseInt(price) : 0,
        isExclusive: Boolean(isExclusive),
        creationDate: new Date(),
    }

    if (isDemandValid(goldenDemand)) {
        await post(`${URL_BASE}/demands/golden`, goldenDemand, {
            headers: {
                'Authorization': `Bearer ${Store.getState().authState.loggedUser}`
            }
        },
            (error) => {
                const { status, data } = error;
                handleErrors(status, data);
            });
    } else {
        throw Error("demand invalid");
    }
}

function isDemandValid(goldenDemand) {
    if (!Boolean(goldenDemand.category)) {
        Store.dispatch(showWarning("Select a category."));
        return false;
    }

    if (goldenDemand.description.length <= 0) {
        Store.dispatch(showWarning("You need a description about the job."));
        return false;
    }

    if (!Boolean(goldenDemand.stateCode)) {
        Store.dispatch(showWarning("Select a State."));
        return false;
    }

    if (!Boolean(goldenDemand.city)) {
        Store.dispatch(showWarning("Select a City."));
        return false;
    }

    if (goldenDemand.customerContact.length <= 0) {
        Store.dispatch(showWarning("You to define a demand's customer contact."));
        return false;
    }

    if (!goldenDemand.customerContact.match(/^[+]*[(]{0,1}[0-9]{3}[)]{0,1}[\\s]{0,1}[-\\./0-9]{3}[-]{1}[-\\./0-9]{4}$/) <= 0) {
        Store.dispatch(showWarning("Demand's customer contact is invalid."));
        return false;
    }

    if (goldenDemand.customerName.length <= 0) {
        Store.dispatch(showWarning("You to define a demand's customer name."));
        return false;
    }

    return true;
}
export default {
    createGoldenDemand,
    getAllGoldenDemands,
    changeStatus,
    createDemandAndAccount,
    getAllDemands,
    deleteDemand,
    finishDemand
}